import * as React from 'react';
import { Component } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import {
  listPossibleLeaveParticipants,
  listPossibleLeaveReasons,
} from '../../redux/actions/table/timesheets';
import styles from '../../styles/forms/timesheets/EditUserLeaveForm.scss';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual';
import Localization from '../../helpers/Localization';
import { __ } from '../../core/utils';
import Select from '../../components/Select';
import Input from '../../components/Input';
import Textarea from '../../components/Textarea';
import Checkbox from '../../components/Checkbox';
import DateTimePicker from '../../components/DateTimePicker';
import { enableAutosave } from '../../redux/actions/general/autosave';
import PeopleChooser from '../../components/PeopleChooser';

@reduxForm({
  form: 'timesheets.edit_userleave',
  enableReinitialize: true,
})
@withRouter
@subscribe(Localization, 'localization')
class EditUserLeaveForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      possible_leave_reasons: [],
      possible_leave_participants: [],
    };
  }

  UNSAFE_componentWillReceiveProps() {
    enableAutosave(this.props.form);
  }

  componentDidMount() {
    listPossibleLeaveReasons().then(({ response }) => {
      this.setState({ possible_leave_reasons: response.data });
    });

    listPossibleLeaveParticipants().then(({ response }) => {
      this.setState({
        possible_leave_participants: {
          ..._.map(response.data, (row) => {
            return { ...row, name: row.fullname };
          }),
        },
      });
    });
  }

  render() {
    const possibleMinutes = [
      { value: '0', label: '00' },
      { value: 15, label: '15' },
      { value: 30, label: '30' },
      { value: 45, label: '45' },
    ];

    const { possible_leave_reasons, possible_leave_participants } = this.state;

    const { values } = this.props.data;

    return (
      <Form className={styles.wrapper}>
        <div className={styles.section}>
          {this.props?.data?.minutes == null ? (
            <div className={styles.f5}>
              <Field
                name='date'
                component={DateTimePicker}
                label={__('table.columns.task-date-time')}
                footer
                range
                presets
              />
            </div>
          ) : (
            <>
              <div className={styles.flex}>
                <div className={styles.f2}>
                  <Field
                    name='date'
                    component={DateTimePicker}
                    label={__('table.columns.timesheet-date')}
                    footer
                  />
                </div>
                <div className={styles.f4} />
              </div>
              <div className={styles.flex}>
                <div className={styles.f1}>
                  <Field
                    name='hours'
                    component={Input}
                    label={__('table.columns.timesheet-hours')}
                    numeric
                    maxLength={4}
                    hint={__('timesheets.hint.in-hours')}
                  />
                </div>
                <div className={styles.f1}>
                  <Field
                    name='minutes'
                    component={Select}
                    searchable
                    options={possibleMinutes}
                    label={__('table.columns.timesheet-minutes')}
                  />
                </div>
                <div className={styles.f2} />
              </div>
            </>
          )}

          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                name='leave_reason_id'
                component={Select}
                searchable
                options={_.map(possible_leave_reasons, (leaveReason) => ({
                  value: leaveReason.id,
                  label: leaveReason.name,
                }))}
                label={__('table.columns.timesheet-reason')}
                placeholder={__('edit-user-leave-form.select-reason')}
              />
            </div>
          </div>
          <Field
            name='description'
            component={Textarea}
            label={__('add-timesheet-form.description')}
            maxLength={200}
            rows={1}
            maxRows={5}
            placeholder={__('edit-user-leave-form.add-description')}
          />
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                name='approvers'
                component={PeopleChooser}
                label={__('table.columns.timesheet-approvers')}
                searchable
                options={possible_leave_participants}
                placeholder={__('edit-user-leave-form.select-approvers')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                name='followers'
                component={PeopleChooser}
                label={__('table.columns.timesheet-followers')}
                searchable
                options={possible_leave_participants}
                placeholder={__('edit-user-leave-form.select-followers')}
              />
            </div>
          </div>
        </div>
      </Form>
    );
  }
}

export default EditUserLeaveForm;
